module.exports = __webpack_public_path__ + "assets/images/flag-fr-4e25aeca363950eaf0ea533f22e718bf.png";